import { Image, Select, Text } from "@chakra-ui/react";
import styled from "styled-components";

export const DashBoardProdutividadeDetalhadaContainer = styled.div`
  margin-top: 15px;
  background-color: #f9fbfb;
  font-family: Akrobat;
`;
export const DashBoardProdutividadeDetalhadaContainerText = styled.div`
  background-color: #d79576;
  padding: 15px 0;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const DashBoardProdutividadeDetalhadaContent = styled.div`
  width: 100%;
  background-color: white;
  margin-top: 0.5rem;
`;
export const ContentHeaderFilter = styled.div`
  width: 1200px;
  height: 200px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;
export const ContentHeaderFilterContainer = styled.div`
  width: 1120px;
  height: 173px;
  display: flex;
  justify-content: center;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  border-radius: 8px;
  background-color: white;
  box-shadow: 2px 2px 15px 2px rgba(0, 0, 0, 0.089);
`;
export const ContentHeaderFilterContainerBox = styled.div`
  width: 500px;
  height: 100%;
  position: relative;
`;
export const ContentHeaderFilterContainerBoxFilter = styled.div`
  position: relative;
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
`;

export const ContentHeaderFilterContainerBoxFilterTimeLine = styled.div`
  position: relative;
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  width: 500px;
  height: 60px;
`;

export const TimeLine = styled.div`
  width: 100%;
  height: 50px;
  margin-top: 0.5rem;
  label {
    font-weight: bold;
    color: rgb(61, 61, 61);
  }

  .green {
    label {
      color: gray;
      strong {
        color: #17b35d;
      }
    }
  }

  .red {
    label {
      color: gray;
      strong {
        color: #eb4424;
      }
    }
  }
`;
export const ContentHeaderFilterContainerBoxFilterSelect = styled.div`
  width: 500px;
  height: 40px;
  display: flex;
  .checkbox {
    width: 250px;
    height: 40px;
    display: flex;
    align-items: none;
    justify-content: end;
    font-size: 14px;
    input {
      width: 30px;
      position: relative;
      float: left;
      left: 30px;
    }

    select {
      width: 220px;
      position: relative;
    }
  }

  label {
    width: 170px;
    height: 40px;
    color: rgb(61, 61, 61);
    font-family: "Akrobat ExtraBold";
    display: flex;
    align-items: center;
    font-size: 14px;
    color: gray;
    strong {
      color: gray;
      justify-content: center;
      position: relative;
      left: 10px;
      font-size: 20px;
      font-family: "Akrobat ExtraBold";
    }
  }
  select {
    width: 100px;
    height: 30px;
    justify-content: center;
align-items: center;
    border: 0px;
    border-radius: 3px;
    font-size: 15px;
    background-color: #f0f4f5;
    color: gray;
    font-family: "Akrobat";
    -moz-appearance: none;
    // background-image: url("/images/seta.png");
    background-repeat: no-repeat;
    background-position-x: 98%;
    background-position-y: 50%;
  }
`;
export const SelectBox = styled(Select)`
  font-family: Akrobat SemiBold;
  box-shadow: none !important;
`;
export const SelectVendedor = styled.div`
  width: 200px;
  height: 40px;
  display: flex;
  align-items: center;
  margin-top: 0.1rem;
  margin-left: -1rem;

  .produtividade {
    width: 300px;
    border-radius: 3px;
    background-color: white;
    display: flex;
    justify-content: center;
  }

  .checkbox {
    width: 250px;
    height: 40px;
    display: flex;
    align-items: none;
    justify-content: end;
    font-size: 14px;
    input {
      width: 30px;
      position: relative;
      float: left;
      left: 30px;
    }
    label {
      width: 90px;
      left: 30px;
      position: relative;
      float: left;
      font-size: 14px;
    }
    select {
      width: 110px;
      position: relative;
      float: left;
    }
  }

  select {
    width: 170px;
    height: 30px;
    border: 0px;
    border-radius: 3px;
    font-size: 15px;
    background-color: #f0f4f5;
    color: gray;
    font-family: "Akrobat";
    outline: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-repeat: no-repeat;
    background-position-x: 98%;
    background-position-y: 50%;
    
  }
`;
export const BoxRanking = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  align-items: center;
  display: flex;
  margin-top: -1.5rem;
  justify-content: space-around;
`;
export const BoxRankingContainer = styled.div`
  width: 180px;
  height: 110px;
  margin-left: 10px;
  text-align: center;
  p {
    margin-top: 0.1rem;
    font-weight: bold;
    height: 30px;
    margin-left: 0.5rem;
    color: gray;
  }
  h4 {
    color: #FD9044;
    font-size: 25px;
    margin-left: 0.5rem;
    font-family: "Akrobat Extrabold";

  }
  h6 {
    color: #FD9044;
    font-size: 25px;
    margin-left: 0.5rem;
    font-family: "Akrobat Extrabold"
  }
  h5 {
    font-weight: bold;
    color: gray;
  }
`;
export const BoxRankingContainerGoal = styled.div`
  width: 125px;
  height: 40px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  color: rgb(61, 61, 61);
`;

export const BoxRankingContainerGoalPlace = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: gray;
  display: flex;
  align-items: center;
  text-align: center;
  margin-top: 5px;
  font-family: "Akrobat ExtraBold"
  .icon {
    margin-right: 5px;
  }
`;
export const ImageRanking = styled(Image)`
  width: 40px;
  height: 40px;
  display: inline-flex;
  align-items: center;
  background-size: 40px auto;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
`;
export const ContainerContentDashboard = styled.div`
  width: 1600px;
  height: 360px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
`;
export const ContainerContentDashboardSecond = styled.div`
  width: 1120px;
  margin-left: 45px;
  position: relative;
  float: left;
`;
export const ContentDashboardLoading = styled.div`
  width: 100%;
  height: 700px;
  position: absolute;
  z-index: 9999;
  background-color: #ffffff;
`;
export const ContentDashboardLoadingContent = styled.div`
  width: 100px;
  height: 100px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  top: 20%;
  background-color: #fff;
  // background-color: royalblue;
`;
export const ContentDashboardContainer = styled.div`
  width: 1512px;
  height: 343px;
  display: flex;
  justify-content: flex-start;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  border-radius: 12px;
  background-color: white;
  box-shadow: 2px 2px 15px 2px rgba(0, 0, 0, 0.089);
`;
export const ContentDashboardContainerTwo = styled.div`
  width: 1120px;
  height: 343px;
  display: flex;
  justify-content: flex-start;
  position: relative;
  margin-left: 45px;
  margin-right: auto;
  float: left;
  border-radius: 12px;
  background-color: white;
  box-shadow: 2px 2px 15px 2px rgba(0, 0, 0, 0.089);
`;
export const ContentDashboardContainerClientes = styled.div`
  width: 365px;
  margin-left: 25px;
  position: relative;
  float: left;
  height: 343px;
  display: flex;
  justify-content: flex-start;
  position: relative;
  margin-right: auto;
  border-radius: 12px;
  background-color: white;
  box-shadow: 2px 2px 15px 2px rgba(0, 0, 0, 0.089);
`;
export const DashClientes = styled.div`
  height: 100%;
  color: gray;

  width: 310px;

  position: relative;
  // background-color: #a4bcec;
  margin-left: 20px;
`;
export const ContainerDashHeader = styled.div`
  width: 100%;
  height: 47px;
`;
export const ContentDashboardContainerPreFixo = styled.div`
  width: 85px;
  height: 100%;
  position: relative;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  background-color: #c7c8ca;
  .line {
    width: 95%;
    height: 18.5px;
    position: relative;
    // background-color: rosybrown;
    margin-top: 5px;

    h1 {
      font-size: 12px;
      color: rgb(255, 255, 255);
      text-align: right;
    }
  }
`;
export const DashboardContainerBash = styled.div`
  width: 250px;
  height: 100%;
  position: relative;
  color: gray;
  margin-left: 20px;
  .header {
    width: 100%;
    height: 47px;
    color: gray;
    .title {
      width: 90%;
      height: 100%;
      display: flex;
      color: gray;
      justify-content: space-between;
      align-items: center;

      .custom {
        width: 85%;
        float: right;
      }
      .clientes {
        width: 70%;
        float: right;
      }

      p {
        width: 100%;
        font-size: 16px;
        // text-align: center;
      }
    }
  }
  .clientes {
    width: 310px;
  }
`;
export const DashboardContainerDashSecond = styled.div`
  width: 250px;
  height: 100%;
  position: relative;
  color: gray;
    margin-left: 20px;
  .clientes {
    width: 310px;
  }
  .header {
    width: 100%;
    height: 47px;
    // background-color: royalblue;
  }
`;

export const TitleClientes = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  float: right;
  p {
    width: 100%;
    font-size: 16px;
    // text-align: center;
  }
  h6{
    font-size: 20px;
    color: #a05178;
  }
`;

export const DashboardContainerBashHeader = styled.div`
  width: 90%;
  height: 47px;
  color: gray;
    margin-left: 0.5rem;
`;
export const DashboardContainerBashHeaderTitle = styled.div`
  width: 95%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  p{
    font-size: 20px;
  }
  h6{
    font-size: 20px;
    color: #f68e4a;
  }
  .clientes {
    width: 70%;
    float: right;
  }
`;
export const DashboardContainerBashHeaderTitleClientes = styled.div`
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 70%;
  float: right;
`;
export const DashboardContainerBashHeaderTitleCustom = styled.div`
  width: 100%;
  float: right;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h1 {
    
    width: 100%;
    font-size: 16px;
    color: gray;

    // text-align: center;
  }
  h6{
    font-size: 20px;
    color: #8f7dba;
  }
`;

export const DashboardContainerBashBody = styled.div`
  width: 100%;
  height: 281px;

  // background-color: rgb(65, 225, 86);
`;
export const DashboardContainerBashBodyProgress = styled.div`
  width: 100%;
  height: 18.5px;
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  // background-color: sienna;

  p {
    width: 35px;
    font-family: "Akrobat SemiBold";
    margin-right: 5px;
    margin-left: 5px;
    color: gray;
  }
  h1 {
    margin-left: 10px;
  }
`;

export const DashboardContainerBashBodyBarProgress = styled.div`
  width: 100%;
  height: 18.5px;
  margin-top: 0px;
  border-radius: 15px;

  background-color: #ebebeb;

  p {
    width: 10%;
    font-family: "Akrobat SemiBold";
    margin-right: 5px;
    margin-left: 5px;
  }
  .progress {
    width: 100%;
    height: 100%;
    
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    // border-radius: 15px;
    background-color: #12a499;
  }

  .value {
    width: 100px;
    height: 30px;
    position: relative;
    top: -25px;
    left: 42%;
    background-color: transparent;

    p {
      width: 100%;
      position: relative;
      top: 7px;

      font-size: 13px;
      font-family: "Akrobat SemiBold", sans-serif;
      color: rgb(61, 61, 61);
      text-align: right;
    }
  }
`;

export const DashboardContainerBashBodyBarProgressClientes = styled.div`
  width: 60%;
  height: 18.5px;
  margin-top: 0px;
  border-radius: 15px;
  background-color: #ebebeb;
  .progress {
    width: 100%;
    height: 100%;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    // border-radius: 15px;
    background-color: #12a499;
  }

  .value {
    width: 100px;
    height: 30px;
    position: relative;
    top: -25px;

    left: 42%;
    background-color: transparent;

    p {
      width: 100%;
      position: relative;
      top: 7px;

      font-size: 13px;
      font-family: "Akrobat SemiBold", sans-serif;
      color: rgb(61, 61, 61);
      text-align: right;
    }
  }
`;
export const DashboardContainerBashBodyBarProgressPedidos = styled.div`
  width: 100%;
  height: 18.5px;
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  // background-color: sienna;

  p {
    width: 30px;
    font-family: "Akrobat SemiBold";
    margin-right: 5px;
    margin-left: 5px;
  }
`;
export const ProgressPedidos = styled.div`
  width: 87%;
  height: 18.5px;
  margin-top: 0px;
  border-radius: 15px;
  background-color: #ebebeb;

  .progress {
    width: 100%;
    height: 100%;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    // border-radius: 15px;
    background-color: #12a499;
  }

  .value {
    width: 100px;
    height: 30px;
    position: relative;
    top: -25px;
    left: 38%;
    background-color: transparent;

    p {
      width: 100%;
      position: relative;
      top: 7px;
      font-size: 13px;
      font-family: "Akrobat SemiBold", sans-serif;
      color: rgb(61, 61, 61);
      text-align: right;
    }
  }
`;
export const ProgressClientes = styled.div`
  width: 100%;
  height: 18.5px;
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  // background-color: sienna;

  p {
    width: 91.5px;
    font-family: "Akrobat SemiBold";
    text-align: right;
    margin-right: 5px;
  }
  h1 {
    width: 10%;
    font-size: 15px;
    font-family: "Akrobat SemiBold";
    text-align: right;
  }
`;
export const BarProgressClientes = styled.div`
  width: 60%;
  height: 18.5px;
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  // background-color: sienna;

  p {
    width: 30%;
    font-family: "Akrobat SemiBold";
    text-align: right;
    margin-right: 5px;
  }
  h1 {
    width: 10%;
    font-size: 15px;
    font-family: "Akrobat SemiBold";
    text-align: right;
  }
`;
export const BarProgressPedidos = styled.div`
  width: 60%;
  height: 18.5px;
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  // background-color: sienna;

  p {
    width: 30%;
    font-family: "Akrobat SemiBold";
    text-align: right;
    margin-right: 5px;
  }
  h1 {
    width: 10%;
    font-size: 15px;
    font-family: "Akrobat SemiBold";
    text-align: right;
  }
`;
export const ContainerClientes = styled.div`
  width: 365px;
  margin-left: 25px;
  position: relative;
  float: left;
`;
export const DashCliente = styled.div`
  width: 310px;
`;

export const BarProgressCss = styled.div`
  width: 60%;
  height: 18.5px;
  margin-top: 0px;
  border-radius: 15px;
  background-color: #ebebeb;
  .progress {
    width: 100%;
    height: 100%;
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
    // border-radius: 15px;
    background-color: #12a499;
  }
  p {
    width: 100%;
    position: relative;
    top: 7px;
    font-size: 13px;
    font-family: "Akrobat SemiBold", sans-serif;
    color: rgb(61, 61, 61);
    text-align: right;
  }
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 100%;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  // border-radius: 15px;
  background-color: #12a499;
`;
export const ProgressValue = styled.div`
  width: 100px;
  height: 30px;
  position: relative;
  top: -25px;
  left: 42%;
  background-color: transparent;

  p {
    width: 100%;
    position: relative;
    top: 7px;
    font-size: 13px;
    font-family: "Akrobat SemiBold", sans-serif;
    color: rgb(61, 61, 61);
    text-align: right;
  }
`;